(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const desktopHeroMedia = window.matchMedia('(min-width: 750px)');

  const loadDesktopHeroVideos = () => {
    if (!desktopHeroMedia.matches) return;

    document.querySelectorAll('[data-desktop-hero-video]').forEach((video) => {
      if (video.dataset.loaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.poster = video.dataset.poster;
      video.dataset.loaded = 'true';
      video.load();
      video.play().catch(() => {});
    });
  };

  loadDesktopHeroVideos();
  desktopHeroMedia.addEventListener('change', loadDesktopHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
